import React, { useRef } from "react";
import "./contact.css";
import { MdEmail } from "react-icons/md";
import { FaSlack } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const btn = document.getElementById("submit");

    emailjs
      .sendForm(
        "service_1uzacx6",
        "template_38cbmtw",
        form.current,
        "2CIYXwhGN-Bz_gd_f"
      )
      .then(
        (result) => {
          btn.classList.toggle("success");
          setTimeout(() => btn.classList.toggle("success"), 2000);
        },
        (error) => {
          btn.classList.toggle("fail");
          setTimeout(() => btn.classList.toggle("fail"), 2000);
        }
      );
  };
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>maen.ghanem1997@gmail.com</h5>
            <a target="_blank" href="mailto:maen.ghanem1997@gmail.com">
              Send me an Email
            </a>
          </article>
          <article className="contact__option">
            <FaSlack className="contact__option-icon" />
            <h4>Slack</h4>
            <h5>ToyChan Slack</h5>
            <a
              target="_blank"
              href="https://join.slack.com/t/toychan/shared_invite/zt-1iqasx1k6-ufxDVWyOH5roOeKoC7PMxg"
            >
              Join Slack
            </a>
          </article>
          <article className="contact__option">
            <FaWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <h5>+970594952252</h5>
            <a
              target="_blank"
              href="https://api.whatsapp.com/send?phone=00970594952252"
            >
              Send me a message
            </a>
          </article>
          <article className="contact__option">
            <FaDiscord className="contact__option-icon" />
            <h4>Discord</h4>
            <h5>Ma'in#6573</h5>
            <a target="_blank" href="https://discord.gg/mmT8zbrFD3">
              Send me a message
            </a>
          </article>
        </div>
        {/*END OF CONTACT OPTIONS*/}
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your full name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button
            type="submit"
            id="submit"
            className="btn btn-primary contact-btn"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
